import React, { Component } from 'react';
import Card from '../Card'

const teachers = [
  {
    name: "Elvira Deutges",
    picturePath: "https://res.cloudinary.com/mcfrihfd/image/upload/v1601927422/project2React/about/Elvira.jpg",
    cv: <span>
    Ausbildung:<br/>
    1982 – 1984 Fachoberschule mit Fachabitur Bekleidung<br/>
    1984 – 1986 Ausbildung zur Bekleidungsschneiderin<br/>
    1986 – 1991 Beschäftigung als Musternäherin<br/>
    1991 – 2002 Selbstständigkeit als Maßatelier<br/>
    Seit 1990 tätig in der Erwachsenenbildung<br/>
    Weiterbildung:<br/>
    1987 – 1990 Ausbildung zum Industrieschneidermeisterin<br/>
    (mit Anerkennung im Handwerk)<br/>
    1992 Ausbildung zur Schnittdirectrice</span>
  }
]

export default class About extends Component {
  renderCards=()=>{
    return teachers.map(teacher=>
      <Card 
        key = {teacher.name}
        id = {teacher.name}
        imgPath = {teacher.picturePath}
        imgName = {teacher.name}
        header = {teacher.name}
        text = {teacher.cv}
      />)
  }
  render() {                
    return (
      <div className="about">
        <h2 className="title">Über uns</h2>
        <div className="card-block">
          {this.renderCards()}
        </div>
      </div>
    );
  }
}